import { WithdrawAmountWidget } from "./ui/withdraw_amount.widget";

export default WithdrawAmountWidget;
